import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./notfoundpage.css";

import { Jumbotron, Container, Col, Row, Button } from "reactstrap";

const NotFoundPage = props => {
  return (
    <div
      style={{
        backgroundColor: "#26272d",
        paddingTop: "50px",
        paddingBottom: "150px"
      }}
    >
      <Row className="text-center">
        <Col lg={{ size: 6, offset: 3 }}>
          <h1>Welcome To The 404</h1>
          <h3>
            Oops! Looks like the power’s out on this page. Sorry about that. Our
            team in the 404 will look into this as soon as possible.{" "}
          </h3>
        </Col>
      </Row>
      <Jumbotron className="py-0" fluid>
        <Container className="error-jumbo" fluid></Container>
      </Jumbotron>

      <Link
        to="/"
        className="btn-link d-flex justify-content-center"
      >
        <Button className="btn typ-btn">Return Home</Button>
      </Link>
    </div>
  );
};

export default NotFoundPage;
